import { render, staticRenderFns } from "./download-xp.vue?vue&type=template&id=e50b9920&"
import script from "./download-xp.vue?vue&type=script&lang=js&"
export * from "./download-xp.vue?vue&type=script&lang=js&"
import style0 from "./download-xp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports